

import TransformUtil from "./TransformUtil"

class CameraUtil {

    constructor(camera) {
        this.camera = camera;
    }


    getCameraPosition() {
        let position = TransformUtil.transformCartesianToWGS84(this.camera.positionWC)
        if (position) {
            position.heading = Cesium.Math.toDegrees(this.camera.heading)
            position.pitch = Cesium.Math.toDegrees(this.camera.pitch)
            position.roll = Cesium.Math.toDegrees(this.camera.roll)
        }
        return position || {}
    }
}

export default CameraUtil;